import ILSListSizeLabel from 'automation-ui-enrollment/components/enrollment/manual/ILSListSizeLabel';
import ILSListSizeEstimateLabel, { StyledUILoadingSpinner } from 'automation-ui-enrollment/components/enrollment/manual/ILSListSizeEstimateLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const getEnrollModeHasFilters = enrollMode => {
  return enrollMode === 'ENROLL_FROM_TRIGGERS' || enrollMode === 'ENROLL_CUSTOM';
};
const ListCountFromMode = ({
  enrollMode,
  objectTypeId,
  listId,
  filterBranch,
  objectCount
}) => {
  if (enrollMode === 'ENROLL_FROM_LIST' || getEnrollModeHasFilters(enrollMode) && listId) {
    return /*#__PURE__*/_jsx(ILSListSizeLabel, {
      listId: listId,
      objectTypeId: objectTypeId
    });
  } else if (enrollMode === 'ENROLL_INDIVIDUAL') {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: objectCount
    });
  } else {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: filterBranch ? /*#__PURE__*/_jsx(ILSListSizeEstimateLabel, {
        filterBranch: filterBranch,
        objectTypeId: objectTypeId
      }) : /*#__PURE__*/_jsx(StyledUILoadingSpinner, {
        size: "extra-small",
        className: "p-all-0 m-all-1"
      })
    });
  }
};
export default ListCountFromMode;